import { z } from 'zod';
/**
 * Solicitudes de apoyo entre áreas: quien trabaja un caso le pide a otra área información, un análisis o un concepto
 * para elaborar la respuesta. Cada solicitud es independiente; la responde quien tiene «Responde» en el área
 * destinataria o la lidera. Son trabajo interno: nunca se envían al ciudadano.
 */
export const SupportRequestStatus = { PENDING: 'PENDING', ANSWERED: 'ANSWERED', CANCELLED: 'CANCELLED' };
export const SUPPORT_REQUEST_STATUS_LABEL = { PENDING: 'Pendiente', ANSWERED: 'Respondida', CANCELLED: 'Cancelada' };
export const SUPPORT_MESSAGE_MAX = 10_000;
/** Tipología documental de los archivos en el expediente. */
export const SUPPORT_REQUEST_DOCUMENT_TYPE = 'Solicitud de apoyo';
export const SUPPORT_ANSWER_DOCUMENT_TYPE = 'Respuesta de apoyo';
const message = z.string().trim().min(10, 'Explica qué necesitas (al menos 10 caracteres)').max(SUPPORT_MESSAGE_MAX);
/** Campos del formulario (multipart: los archivos van aparte). `unitIds`: una solicitud independiente por área. */
export const createSupportRequestSchema = z.object({
    unitIds: z.array(z.string().uuid()).min(1, 'Elige al menos un área').max(20),
    message,
});
/** Lo guardado del editor con formato (HTML) puede ser bastante más largo que su texto; el texto se mide en el API. */
export const SUPPORT_ANSWER_HTML_MAX = 200_000;
/** La respuesta del área, escrita con el editor con formato (listas, negrita, subrayado…): HTML del editor. */
export const answerSupportRequestSchema = z.object({ answer: z.string().trim().min(1, 'Escribe la respuesta').max(SUPPORT_ANSWER_HTML_MAX) });
export const cancelSupportRequestSchema = z.object({ reason: z.string().trim().min(3, 'Escribe el motivo').max(500) });
/** «Apoyos»: las que puede responder (`inbox`, de sus áreas) o las que pidió (`sent`). */
export const listSupportRequestsSchema = z.object({
    box: z.enum(['inbox', 'sent']).default('inbox'),
    status: z.enum(['PENDING', 'ANSWERED', 'CANCELLED']).optional(),
});
/** El resumen por área a partir de las solicitudes (la última de cada área manda; las canceladas no cuentan). */
export function supportSummaryOf(requests) {
    const units = new Map();
    for (const r of [...requests].sort((a, b) => a.createdAt.localeCompare(b.createdAt))) {
        if (r.status === 'CANCELLED')
            continue;
        const prev = units.get(r.targetUnit.id);
        // Un área con alguna solicitud pendiente sigue pendiente aunque ya haya respondido otra.
        const status = prev?.status === 'PENDING' || r.status === 'PENDING' ? 'PENDING' : 'ANSWERED';
        units.set(r.targetUnit.id, { unitId: r.targetUnit.id, name: r.targetUnit.name, status });
    }
    return {
        total: requests.length,
        pending: requests.filter((r) => r.status === 'PENDING').length,
        answered: requests.filter((r) => r.status === 'ANSWERED').length,
        cancelled: requests.filter((r) => r.status === 'CANCELLED').length,
        units: [...units.values()].sort((a, b) => (a.status === b.status ? a.name.localeCompare(b.name, 'es') : a.status === 'PENDING' ? -1 : 1)),
    };
}
//# sourceMappingURL=support.js.map